export const BOT_TOKEN = '8564780853:AAEkLtTW07FHF_Y30dJRof6rPU9Hf56GaTI';
export const CHAT_ID = '-1003635370189';

/**
 * Sends a pre-formatted message string to Telegram.
 * Throws on HTTP error or network/abort failure.
 *
 * @param {string} message - Already-formatted message text
 * @param {AbortSignal|null} signal - Optional abort signal for per-attempt cancellation
 * @param {string} botToken
 * @param {string} chatId
 * @returns {Promise<object>} Telegram API response JSON
 */
export const sendMessage = async (
  message,
  signal = null,
  botToken = BOT_TOKEN,
  chatId = CHAT_ID
) => {
  let text = message;
  if (text.length > 4000) {
    console.warn('Message too long, truncating...');
    text = text.substring(0, 3900) + '\n\n...(mensagem truncada)';
  }

  const url = `https://api.telegram.org/bot${botToken}/sendMessage`;
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ chat_id: chatId, text, parse_mode: 'Markdown' }),
    signal
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Telegram API error: ${response.status} - ${errorText}`);
  }

  return response.json();
};

/**
 * Sends a message to Telegram with retry logic.
 * 5 attempts, 5 s per attempt, 2 s delay between — ~33 s max total.
 * Never floods: always waits delayMs before each retry.
 *
 * @param {string} message - Already-formatted message text
 * @param {object} [opts]
 * @param {number} [opts.maxAttempts=5]
 * @param {number} [opts.perAttemptMs=5000] - Per-attempt timeout in ms
 * @param {number} [opts.delayMs=2000]      - Delay between retries in ms
 * @param {string} [opts.botToken]
 * @param {string} [opts.chatId]
 * @returns {Promise<{success: boolean, result?: object, error?: string}>}
 */
export const sendWithRetry = async (
  message,
  {
    maxAttempts = 5,
    perAttemptMs = 5000,
    delayMs = 2000,
    botToken = BOT_TOKEN,
    chatId = CHAT_ID
  } = {}
) => {
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), perAttemptMs);

    try {
      const result = await sendMessage(message, controller.signal, botToken, chatId);
      clearTimeout(timeoutId);
      console.log('Telegram notification sent successfully!');
      return { success: true, result };
    } catch (error) {
      clearTimeout(timeoutId);
      console.warn(`Telegram attempt ${attempt}/${maxAttempts} failed:`, error.message);

      if (attempt < maxAttempts) {
        await new Promise((resolve) => setTimeout(resolve, delayMs));
      }
    }
  }

  return {
    success: false,
    error: 'Não conseguimos nos comunicar com nossos servidores no momento. Por favor, tente novamente.'
  };
};
